
import leftSide from "@/components/getInTouch/LeftSide.vue";
import rightSide from "@/components/getInTouch/RightSide.vue";
export default {
    components: {
      rightSide,
      leftSide
    }
}
